export const GA_LABEL = {
    FROM_CLAN_LANDING_SCREEN: 'Clan page click',
    FROM_STRONGHOLD_SCREEN: 'Panel click',
    FROM_INGAME_SHOP_BANNER: 'Banner click',
    PACKAGE_S: 'Click package_s',
    PACKAGE_M: 'Click package_m',
    PACKAGE_L: 'Click package_l',
    PACKAGE_XL: 'Click package_xl',
    CLOSE_CLICK: 'Click bundle close',
    BUY: 'Click buy',
    BACK_CLICK: 'Click back_l',
    CANNOT_BUY_CLICK: 'Click close',
    CONGRATULATION_CLOSE_CLICK: 'Click close',
    MAX_PRODUCTS_LIMIT: 'Forbidden to buy more offers',
    NO_MONEY: 'Not enough money to buy offer',
    JOIN_AFTER_ACTION_START: 'Was already in a clan',
}

export const GA_ACTIONS = {
    TO_STOREFRONT: 'Come to offer page',
    STOREFRONT: 'Offer page',
    PREVIEW: 'Preview page',
    CONGRATULATION: 'Congratulation window',
}

export const trackEvent = (eventAction, eventLabel) => {
    window.dataLayer.push({
        event: 'GAevent',
        eventCategory: 'Clan offers promresource',
        eventAction,
        eventLabel,
        realm: window.config.REALM,
        role: window.__WGSH_GA_ROLE__,
    })
}



// WEBPACK FOOTER //
// ./googleAnalytic.js